import isMobile from "is-mobile";

const productItem = node => {
  const imageWrapper = node.querySelector(".product-item__image-wrapper");

  if (imageWrapper && !isMobile()) {
    initImageHover();
  }

  function handleOver(e) {
    const second = imageWrapper.querySelector(".not-first");

    if (second) {
      second.classList.add("visible");
    }
  }

  function handleOut(e) {
    const second = imageWrapper.querySelector(".not-first");

    if (second) {
      second.classList.remove("visible");
    }
  }

  function initImageHover() {
    imageWrapper.addEventListener("mouseover", handleOver);
    imageWrapper.addEventListener("mouseout", handleOut);
  }

  const unload = () => {
    if (imageWrapper) {
      imageWrapper.removeEventListener("mouseover", handleOver);
      imageWrapper.removeEventListener("mouseout", handleOut);
    }
  };

  return { unload };
};

export default productItem;
